baseNewRelicData